import { CommercialRoles } from "@prisma/client";
import { z } from "zod";

export const commercialRoles = {
  admin: "admin",
  commercial: "commercial",
  guest: "guest",
} as const;

const commercialRolesEnum = z.nativeEnum(commercialRoles);

const connectIdSchema = z
  .string()
  .min(10, "Veuillez entrer un ID Connect'Events")
  .optional()
  .or(z.literal(""));
const mailSchema = z
  .string()
  .email("Email invalide")
  .optional()
  .or(z.literal(""));

export const addCommercialSchema = z
  .object({
    connectId: connectIdSchema,
    mail: mailSchema,
    commercialRole: commercialRolesEnum,
    jobTitle: z.string().min(1),
  })
  .refine((data) => data.connectId || data.mail, {
    message: "Veuillez entrer soit un ID Connect'Events, soit un email valide",
    path: ["form"],
  });

export const updateCommercialStructureSchema = z.object({
  commercialRole: commercialRolesEnum,
  jobTitle: z.string().min(1).optional(),
  visibleOnExhibitorPage: z.boolean().optional(),
});

export const defaultAddCommercialValues = {
  connectId: "",
  mail: "",
  commercialRoles: commercialRoles.commercial,
  jobTitle: "",
};

export const defaultUpdateCommercialRoleValues = {
  commercialRole: commercialRoles.commercial,
};

export type AddCommercialSchemaForm = z.infer<typeof addCommercialSchema>;

export type UpdateCommercialStructureForm = z.infer<
  typeof updateCommercialStructureSchema
>;

export const commercialRolesLabels = {
  admin: "Admin",
  commercial: "Commercial",
  guest: "Intervenant",
} as const satisfies Record<CommercialRoles, string>;
